import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[numbersOnly]',
})
export class NumberDirective {
  /**
   * @description If true - dot not allowed (integer only)
   * @type {boolean}
   */
  @Input() public numbersOnly: boolean;
  @Input() public decimals: number;

  constructor(private elRef: ElementRef) {}

  @HostListener('input', ['$event']) public onInputChange(event: Event) {
    const initalValue = this.elRef.nativeElement.value;
    if (this.numbersOnly) {
      this.elRef.nativeElement.value = initalValue.replace(/[^0-9+-]+/g, '');
    } else {
      this.elRef.nativeElement.value = initalValue.replace(
        /[^0-9\.|,+-]+/g,
        ''
      );
      const match = this.elRef.nativeElement.value.match(
        /([+-]?\d*)((\.|,)\d+)?(.*)/
      );
      if (match) {
        if (match[1] && match[2]) {
          this.elRef.nativeElement.value =
            match[1] + match[2].replace(',', '.');
        } else if (match[4]) {
          if (match[0] === match[4]) {
            this.elRef.nativeElement.value = '';
          } else {
            this.elRef.nativeElement.value = match[1] + '.';
          }
        }
      }
    }
    if (this.decimals) {
      const value: string = this.elRef.nativeElement.value;

      if (value) {
        const splitted = value.split('.');

        if (splitted[1] && splitted[1].length > this.decimals) {
          this.elRef.nativeElement.value = this.floor(value);
        }
      }
    }

    if (initalValue !== this.elRef.nativeElement.value) {
      event.stopPropagation();
    }
  }

  public floor(value) {
    const d = Math.pow(10, this.decimals);
    return (parseInt(<any>(value * d), 10) / d).toFixed(this.decimals);
  }
}
